import React from 'react'
import '../css/BisharatMain.css';
import translate from '../languages/translate';
function NotFoundPage() {
    return (
        <div className="page-not-found">
           <h1> {translate("pagenotfound")} </h1>
           <a href="/" className="btn">{translate("back-to-main")} </a>
        </div>
    )
}

export default NotFoundPage
